import { createRequest } from "helpers/tools";

const destinations = {
    salesforce: "salesforce",
    http: "services",
    "microsoft-dynamics": "microsoft-dynamics",
    "high-level": "high-level",
    "sugar-crm": "sugar-crm",
    odoo: "odoo",
    leadsquared: "lsqrd",
    perfex: "perfex",
    "fresh-sales": "fresh-sales",
    vtiger: "vtiger",
    wati: "wati",
    monday: "monday",
    hubspot: "hubspot",
    zendesk: "zendesk",
    zoho: "zoho",
    appsflyer: "appsflyer",
    adjust: "adjust",
    "google-sheets": "google-sheets",
};

export const sendStep1ToServis = async (data) => {
    return await createRequest({
        suffix: `lead/selected-leads`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getServicesAsync = async (value) => {
    if (value) {
        let url;
        if (value === "salesforce") {
            url = "service/salesforce/list";
        } else if (
            value !== "http" &&
            value !== "zoho" &&
            value !== "salesforce" &&
            value !== "b24" &&
            value !== "bigquery" &&
            value !== "google-sheets" &&
            value !== "hubspot"
        ) {
            url = `services/${destinations[value]}/list`;
        } else if (value === "zoho") {
            url = "zoho";
        } else if (value === "b24") {
            url = "service/b24/list";
        } else if (value === "bigquery") {
            url = "service/bigquery/list";
        } else if (value === "google-sheets") {
            url = "service/google-sheets/list";
        } else if (value === "hubspot") {
            url = "service/hubspot/list";
        } else {
            url = destinations[value] || "";
        }
        return await createRequest({
            suffix: `lead/${url}`,
            method: "get",
            handleError: false,
        });
    }
};

export const getSorceApisAsync = async (payload, requestSuffix) => {
    return await createRequest({
        suffix: `lead/source-api${requestSuffix || ""}`,
        method: "get",
        handleError: false,
    });
};

export const getConnectedSourceAsync = async (data) => {
    return await createRequest({
        suffix: `lead/source/last-record`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const postServiceAsync = async (data) => {
    let url;
    if (data && data.destination_type_id) {
        if (data.destination_type_id === "http") {
            url = "service";
        } else {
            url = destinations[data.destination_type_id] || "";
        }
    }
    return await createRequest({
        suffix: `lead/${url}`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const postStep1DatasAsync = async (data) => {
    return await createRequest({
        suffix: `lead/save-source-and-destination`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
export const createSourceAsync = async (data) => {
    return await createRequest({
        suffix: `lead/source-api/store`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const editSource = async (payload, id) => {
    return await createRequest({
        suffix: `lead/source-api/${id}/update`,
        handleError: true,
        method: "post",
        payload,
    });
};

export const saveFilters = async (connection_id, field_mapping_id, data) => {
    return await createRequest({
        suffix: `lead/connection/${connection_id}/field-mapping/${field_mapping_id}/filters`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getServiceDetail = async (service_id) => {
    return await createRequest({
        suffix: `lead/service/${service_id}`,
        method: "get",
        handleError: false,
    });
};

export const editServiceDetail = async (service_id, data) => {
    return await createRequest({
        suffix: `lead/service/${service_id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getAuthServicesList = async () => {
    return await createRequest({
        suffix: `lead/auth`,
        method: "get",
        handleError: false,
    });
};

export const getAuthServiceDetail = async (id) => {
    return await createRequest({
        suffix: `lead/auth/${id}`,
        method: "get",
        handleError: false,
    });
};

export const postCreateAuthService = async (payload) => {
    return await createRequest({
        suffix: `lead/auth`,
        method: "post",
        payload,
        handleError: false,
    });
};

export const postTestAuthService = async (payload) => {
    return await createRequest({
        suffix: `lead/auth/test`,
        method: "post",
        payload,
        handleError: false,
    });
};

export const postDeleteAuthService = async (id) => {
    return await createRequest({
        suffix: `lead/auth/${id}/delete`,
        method: "delete",
        handleError: false,
    });
};

export const putUpdateAuthService = async (id, payload) => {
    return await createRequest({
        suffix: `lead/auth/${id}/edit`,
        method: "post",
        payload,
        handleError: false,
    });
};
